<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl"  :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btn-bar">
            <div class="left">
                <button class="swb-btn swb-btn-small" v-if="checkActionPerm('create')" @click="addDealInqryVoucher">
                    <span>新增询盘单</span>
                </button>
            </div>
        </div>
        <div class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li :class="{'current': value == checkStateValue}" class="head-item" v-for="(text, value) in dealInqryVoucherQueryStateEnumMap" @click="tabChange(value)">
                        <span>{{text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import appConf from '../../app.conf';
    import userApi from '../../api/user'
    import dealApi from '../../api/deal'

    import { getDefaultPageSizes } from '../../app.conf'

    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
    import { showBizAuditDlg } from '../merchant/showSelectDlg'

    import { checkUserActionPerm } from '../index'

    import SwbDealInqryVoucherInfo from './DealInqryVoucherInfo';

    Vue.regist(SwbDealInqryVoucherInfo);

    import SwbDealInqryVoucherApply from './DealInqryVoucherApply';

    Vue.regist(SwbDealInqryVoucherApply);

    import SwbDealInqryVoucherAudit from './DealInqryVoucherAudit';

    Vue.regist(SwbDealInqryVoucherAudit);

    import SwbDealInqryVoucherSave from './DealInqryVoucherSave';

    Routes.add(SwbDealInqryVoucherSave);

    import SwbDealInqryVoucherSearch from './DealInqyVoucherSearch';

    Vue.regist(SwbDealInqryVoucherSearch);

    export default {
        name: 'swb-deal-inqry-voucher-list',
        path: '/deal/inqry/voucher/list',
        avlActions: 'create|close_overdue|view_detail|modify|apply|close|setTag|sourceMgmt|cancelRelate|audit|publish|finish|delete',
        avlActionNames: '新增询盘单、关闭已过期、查看详情、修改、申请、关闭、设置标签、搜索询盘标签、来源管理、审核、发布、删除、',
        avlScopes: 'retailer',
        desc: '询盘单列表',
        helpArticleCode: 'retailer-deal-inqry-voucher-list',
        data: function () {
            return {
                //
                confKey:'swb-deal-inqry-voucher-list',
                queryOnLoad: true,
                theTableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 300,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //
                userContext: null,
                postId: null,
                dealInqryVoucherList: [],
                //
                dealInqryVoucherQueryStateEnumMap: [],
                checkStateValue: 0,
                date: null,
                tradeTypeServc: {},
                no: null,
                //
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        created: function () {
            let self = this;
            //----------------------分页--------------------------------
            //
            let no = self.$route.query.no || null;
            this.no = no;
            //----------------------查询------------------------------

            let checkState = self.$route.query.checkState || null;
            if(!Utils.isNoB(checkState)) {
                self.checkStateValue = checkState;
            }
            //
            self.dealInqryVoucherQueryStateEnumMap = getEnumMap('dealInqryVoucherQueryState', 'value2text');
            self.tradeTypeServc = getEnumInfoWith('tradeType', 'name', 'Servc');
            self.date = new Date().format('yyyy-MM-dd');
            //
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type == 'info') {
                    let data = result.data;
                    let userContext = data;
                    self.postId = userContext.scopeEntity.postId;
                    self.userContext = userContext;
                } else {
                    self.$message.error(result.message);
                }
            });
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find(' [name="query-sort-block"], [name="btn-bar"], .tab-container'));
            domSizeWatcher.start(500);
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady:function () {
                let no = this.no;
                if(no != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {value: no};
                    let fieldInfo = {};
                    fieldInfo["no"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'no': function (row, colName, colValue, rowIndex, btnName) {
                        return '<a href="#" class="table-cell-link">' + row.no + '</a>';
                    },
                    'tradeType': function (row, colName, colValue, rowIndex, btnName) {
                        return row.tradeType == self.tradeTypeServc.value ? '<span>' + "服务" + '</span>' : '<span>' + "商品" + '</span> '
                    },
                    'directed': function (row, colName, colValue, rowIndex, btnName) {
                        return row.directed ? '<span>' + "定向" + '</span>' : '<span>' + "公开" + '</span> '
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        let btnList = [];
                        if(self.checkActionPerm('view_detail')) {
                            domHtml = domHtml + '<a name="view_detail" class="swb-btn swb-btn-link">查看详情</a>';
                            btnList.push({
                                name: 'view_detail',
                                text: '查看详情'
                            });
                        }
                        if(self.checkActionPerm('modify') && !row.deleted && row.state == 'Initial' && self.postId == row.creatorPostId) {
                            btnList.push({
                                name: 'modify',
                                text: '修改'
                            });
                        }
                        if(self.checkActionPerm('apply') && !row.deleted && row.state == 'Initial' && self.postId == row.creatorPostId) {
                            btnList.push({
                                name: 'apply',
                                text: '申请'
                            });
                        }
                        if(self.checkActionPerm('audit') && !row.deleted && row.state == 'Applied' && self.postId == row.auditorPostId) {
                            btnList.push({
                                name: 'audit',
                                text: '审核'
                            });
                        }
                        if(self.checkActionPerm('publish') && !row.deleted && row.state == 'AuditPass') {
                            btnList.push({
                                name: 'publish',
                                text: '发布'
                            });
                        }
                        if(self.checkActionPerm('finish') && !row.closed && !row.deleted && row.published && !row.finished) {
                            btnList.push({
                                name: 'finish',
                                text: '结束'
                            });
                        }
                        if(self.checkActionPerm('close') && !row.deleted && !row.closed && row.finished) {
                            btnList.push({
                                name: 'close',
                                text: '关闭'
                            });
                        }
                        if(self.checkActionPerm('delete') && !row.published) {
                            btnList.push({
                                name: 'delete',
                                text: '删除'
                            });
                        }
                        if(self.checkActionPerm('setTag')) {
                            btnList.push({
                                name: 'setTag',
                                text: '设置标签'
                            });
                        }
                        if(self.checkActionPerm('sourceMgmt')) {
                            btnList.push({
                                name: 'sourceMgmt',
                                text: '来源管理'
                            });
                        }
                        if(self.checkActionPerm('cancelRelate') && row.srcFlag > 0) {
                            btnList.push({
                                name: 'cancelRelate',
                                text: '取消来源'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'no': function (row, colName, colValue, rowIndex, btnName) {
                        self.showDealInqryVoucher(row);
                    },
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'view_detail') {
                            self.showDealInqryVoucher(row);
                        } else if(btnName == 'modify') {
                            self.updateDealInqryVoucher(row, self.checkStateValue);
                        } else if(btnName == 'apply') {
                            self.applyDealInqryVoucher(row, self.checkStateValue);
                        } else if(btnName == 'audit') {
                            self.aduitDealInqryVoucher(row, self.checkStateValue);
                        } else if(btnName == 'publish') {
                            self.publishServcRecruit(row, self.checkStateValue);
                        } else if(btnName == 'finish') {
                            self.doFinished(row.id, self.checkStateValue);
                        } else if(btnName == 'close') {
                            self.closedDealInqryVoucher(row, self.checkStateValue);
                        } else if(btnName == 'delete') {
                            self.deleteDealInqryVoucher(row, self.checkStateValue);
                        } else if(btnName == 'setTag') {
                            self.setDealInqryVoucherTag(row, self.checkStateValue);
                        } else if(btnName == 'sourceMgmt') {
                            self.showSourceTraceDlg(row);
                        } else if(btnName == 'cancelRelate') {
                            self.cancelRelate(row.id);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            queryHandler: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getdealInqryVoucherList(this.checkStateValue);
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            //
            showSearch: function (flag) {
                this.searchShow = flag;
            },
            //
            searchTag: function (tag, checkStateValue) {
                this.tag = tag;
                this.searchShow = true;
                this.getdealInqryVoucherList(checkStateValue);
            },
            // 页签切换
            tabChange: function (val) {
                this.pageNumber = 1;
                this.getdealInqryVoucherList(val);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getdealInqryVoucherList(this.checkStateValue);
            },
            getdealInqryVoucherList: function (value) {
                let self = this;
                self.checkStateValue = value;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.closedState = value;
                let dealInqryQueryState = getEnumInfoWith('dealInqryVoucherQueryState', 'value', value);
                if(dealInqryQueryState != null && dealInqryQueryState.name == 'OverDue') {
                    filterItems.finished = false;
                }
                if(!Utils.isNoB(self.no)){
                    filterItems.no = self.no;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let sortItem = self.sortField == null ? null : (self.sortField + ":" + self.sortOrder);
                if(sortItem != null) {
                    let sortItemList = [];
                    sortItemList.add(sortItem);
                    postData.sortItemList = sortItemList
                }
                //
                let lastMsgBoxDlg = MsgBox.loading();
                dealApi.getDealInqryVoucherList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let dealInqryVoucherList = result.data.rows;
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        for(let i = 0, count = dealInqryVoucherList.length; i < count; i++) {
                            let dealInqryVoucher = dealInqryVoucherList[i];
                            if(dealInqryVoucher.publishTime != null) {
                                dealInqryVoucher.publishTime = Date.parseAsDate(dealInqryVoucher.publishTime).format("yyyy-MM-dd");
                            }
                            dealInqryVoucher.merchantCount = dealInqryVoucher.dealInqryMerchtList.length;
                        }
                        self.dealInqryVoucherList = dealInqryVoucherList;
                        self.renderTable(dealInqryVoucherList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            //处理排序事件
            sortListData(sortInfo) {
                this.sortField = sortInfo.prop;
                this.sortOrder = sortInfo.order;
                //
                this.getdealInqryVoucherList(this.checkStateValue);
            },
            //
            updateDealInqryVoucher: function (row, value) {
                let self = this;
                let dlg = Vue.$showDialog({
                    title: "询盘单 - 修改",
                    width: 1400,
                    height: 1000,
                    showCloseBtn: true,
                    template: '<div v-loading="loading" element-loading-text="查询中...">' +
                    '<swb-deal-inqry-voucher-save :id="id" ref="swb_deal_inqry_voucher_save"></swb-deal-inqry-voucher-save>' +
                    '</div>',
                    data: {
                        loading: false,
                        id: []
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_deal_inqry_voucher_save.getDlgResult() || {};
                        if(result.type == "info") {
                            let postData = result.data;
                            dealApi.saveDealInqryVoucher(postData, function (result) {
                                if(result.type == "info") {
                                    self.getdealInqryVoucherList(value);
                                    MsgBox.success("修改成功");
                                    return true;
                                } else {
                                    MsgBox.warning(result.message);
                                }
                                return false;
                            })
                        } else {
                            return false;
                        }
                    },
                    methods: {},
                    lifecycle: {
                        created: function () {
                            this.id = row.id;
                        }
                    }
                });
            },
            showDealInqryVoucher: function (row) {
                let dlg = Vue.$showDialog({
                    title: "询盘单 - 查看",
                    width: 1200,
                    height: 1200,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-deal-inqry-voucher-info :id="id" :showFlag=true ref="swb_deal_inqry_voucher_info"></swb-deal-inqry-voucher-info>' +
                    '</div>',
                    data: {
                        id: []
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    methods: {},
                    lifecycle: {
                        created: function () {
                            this.id = row.id;
                        }
                    }
                });
            },
            applyDealInqryVoucher: function (row, value) {
                let self = this;
                showComActionPostSelectDlg({
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'audit',
                }, function (resultData) {
                    resultData = resultData || {};
                    if(resultData.postId == null) {
                        Toast.show('请选 择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {
                        id: row.id,
                        //
                        auditorPostId: resultData.postId,
                        auditorPostName: resultData.actionPostName,
                        //
                        applyDesc: resultData.applyDesc
                    };
                    //
                    dealApi.applyDealInqryVoucher(postData, function (result) {
                        if(result.type == "info") {
                            MsgBox.success("申请成功");
                            self.getdealInqryVoucherList(value);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                }, this);

//
//                let dlg = Vue.$showDialog({
//                    title: "询盘单 - 申请",
//                    width: 1200,
//                    height: 700,
//                    showCloseBtn: true,
//                    template: '<div v-loading="loading" element-loading-text="查询中...">' +
//                    '<swb-deal-inqry-voucher-apply :id="id" ref="swb_deal_inqry_voucher_apply"></swb-deal-inqry-voucher-apply>' +
//                    '</div>',
//                    data: {
//                        loading: false,
//                        id: []
//                    },
//                    okClicked: function () {
//                        let result = this.$refs.swb_deal_inqry_voucher_apply.getDlgResult() || {};
//                        if(result.type == "info") {
//                            let postData = result.data;
//                            dealApi.applyDealInqryVoucher(postData, function (result) {
//                                if(result.type == "info") {
//                                    MsgBox.success("申请成功");
//                                    self.getdealInqryVoucherList(value);
//                                } else {
//                                    MsgBox.warning(result.message);
//                                }
//                            })
//                        }
//                    },
//                    methods: {},
//                    lifecycle: {
//                        created: function () {
//                            this.id = row.id;
//                        }
//                    }
//                });
            },
            aduitDealInqryVoucher: function (row, value) {
                let self = this;
                showBizAuditDlg({
                    title: "询盘 - 审核",
                    nextPostParams: {
                        rescUrl: Vue.$getClassInfo(this).path,
                        action: 'audit',
                    }
                }, function (resultData) {
                    resultData = resultData || {};
                    let nextPostResultData = resultData.nextPostResultData || null;
                    let auditorPostId = null;
                    if(nextPostResultData != null) {
                        auditorPostId = nextPostResultData.postId;
                    }
                    let postData = {
                        id: row.id,
                        auditState: resultData.auditState,
                        auditDesc: resultData.auditDesc,
                        auditorPostId: auditorPostId,
                    };
                    dealApi.auditDealInqryVoucher(postData, function (result) {
                        if(result.type == "info") {
                            MsgBox.success("审核成功");
                            self.getdealInqryVoucherList(value);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                }, this);

//                let dlg = Vue.$showDialog({
//                    title: "询盘单 - 审核",
//                    width: 1200,
//                    height: 700,
//                    showCloseBtn: true,
//                    template: '<div v-loading="loading" element-loading-text="查询中...">' +
//                    '<swb-deal-inqry-voucher-audit :id="id" audit=true ref="swb_deal_inqry_voucher_audit"></swb-deal-inqry-voucher-audit>' +
//                    '</div>',
//                    data: {
//                        loading: false,
//                        id: []
//                    },
//                    okClicked: function () {
//                        let result = this.$refs.swb_deal_inqry_voucher_audit.getDlgResult() || {};
//                        if(result.type == "info") {
//                            let postData = result.data;
//                            dealApi.auditDealInqryVoucher(postData, function (result) {
//                                if(result.type == "info") {
//                                    MsgBox.success("审核成功");
//                                    self.getdealInqryVoucherList(value);
//                                } else {
//                                    MsgBox.warning(result.message);
//                                }
//                            })
//                        }
//                    },
//                    methods: {},
//                    lifecycle: {
//                        created: function () {
//                            this.id = row.id;
//                        }
//                    }
//                });
            },
            publishServcRecruit: function (row, value) {
                let self = this;
                self.$confirm('此操作将发布该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    if(self.date <= row.expireDate && row.closed == false && row.applyState == 2) {
                        //
                        dealApi.publishDealInqryVoucher(row, function (result) {
                            if(result.type == "info") {
                                MsgBox.success("发布成功");
                                self.getdealInqryVoucherList(value);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    } else {
                        MsgBox.warning("此数据已经关闭或审核未通过")
                    }
                });

            },
            // 结束
            doFinished: function (id, value) {
                let self = this;
                self.$confirm('确定要执行该操作?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    dealApi.doDealInqryVoucherFinished(postData, function (result) {
                        theLoad.hide();
                        if(resultz.type == "info") {
                            MsgBox.success("操作成功");
                            self.getdealInqryVoucherList(value);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })

                }).catch(function () {

                });
            },
            closedDealInqryVoucher: function (row, value) {
                let self = this;
                self.$confirm('此操作将关闭该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    dealApi.closeDealInqryVoucher(row, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            MsgBox.success("关闭成功");
                            self.getdealInqryVoucherList(value);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })

                }).catch(function () {

                });
            },
            deleteDealInqryVoucher: function (row, value) {
                let self = this;
                self.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    dealApi.deleteDealInqryVoucher(row, function (result) {
                        if(result.type == "info") {
                            MsgBox.success("删除成功");
                            self.getdealInqryVoucherList(value);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })

                }).catch(function () {

                });
            },
            addDealInqryVoucher: function () {
                this.$router.push({
                    path: SwbDealInqryVoucherSave.path,
                    query: {
                        checkState: this.checkStateValue,
                    }
                });
            },
            setDealInqryVoucherTag: function (row, value) {
                let self = this;
                Vue.$showDialog({
                    title: '设置标签',
                    showCloseBtn: true,
                    width: 530,
                    height: 300,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>&nbsp;</label>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>标签</label>' +
                    '</div>' +
                    '<div class="form-value width-1-5x">' +
                    '<el-input type="text" v-model="tag"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        tag: row.tag
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        row.tag = selfDlg.tag;
                        let lastMsgBoxDlg = MsgBox.loading();
                        dealApi.updateDealInqryVoucher(row, function (result) {
                            lastMsgBoxDlg.close();
                            if(result.type === "info") {
//                                self.getdealInqryVoucherList(value);
                                MsgBox.success('设置成功!');
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    },
                    lifecycle: {}
                });
            },
            showSourceTraceDlg: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '跟踪信息',
                    showCloseBtn: true,
                    height: 600,
                    template: '<div>' +
                    '<swb-device-require-voucher-for-select :srcId = "srcId" :showSelect="showSelect" :toDeviceRequireVoucherList="toDeviceRequireVoucherList" ref="swb_device_require_voucher_for_select"></swb-device-require-voucher-for-select>' +
                    '</div>',
                    data: {
                        srcId: row.srcId,
                        showSelect: false
                    },
                    methods: {
                        toDeviceRequireVoucherList: function (no) {
                            self.toDeviceRequireVoucherList(no);
                        },
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_device_require_voucher_for_select.getDlgResult() || {};
                        if(result.type == "info") {
                            row.srcId = result.data.srcId;
                            row.srcFlag = result.data.srcFlag;
                            dealApi.updateDealInqryVoucher(row, function (result) {
                                if(result.type === "info") {
                                    MsgBox.success('设置成功');
                                    self.getdealInqryVoucherList(self.checkStateValue);
                                }
                            });
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.showSelect = true;
                        }
                    }
                });
            },
            cancelRelate: function (id) {
                let self = this;
                this.$confirm('是否确定取消此来源 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postParam = {};
                    postParam.id = id;
                    dealApi.cancelDealInqryVoucherSrc(postParam, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('取消成功');
                            self.getdealInqryVoucherList(self.checkStateValue);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            toDeviceRequireVoucherList: function (no) {
                let data = {no: no};
                let hashUrl = Utils.makeUrl("/device/require/voucher/list", data);
                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
            },
            closeOverDueDealInqry: function () {
                this.$confirm('确定要执行该操作?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    dealApi.closeDealInqryVoucherExpired({}, function (result) {
                        if(result.type === "info") {
                            MsgBox.success('关闭成功');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/InqryVoucher/DealInqryVoucherList.vue